import request from "@/utils/request";

export function getMessageList(query) {
  return request({
    url: "/api/merchant/site-message/userl-list",
    method: "get",
    params: query
  });
}

export function messageBatchread(query) {
  return request({
    url: "/api/merchant/site-message/batch-read",
    method: "post",
    params: query
  });
}

export function messageBatchdelete(query) {
  return request({
    url: "/api/merchant/site-message/batch-delete",
    method: "post",
    params: query
  });
}

export function getSignList(query) {
  return request({
    url: "/api/merchant/user-sms/sign/list",
    method: "get",
    params: query
  });
}

export function getValidsignList(query) {
  return request({
    url: "/api/merchant/user-sms/validsign/list",
    method: "get",
    params: query
  });
}

export function editSign(query) {
  return request({
    url: "/api/merchant/user-sms/sign/edit",
    method: "post",
    data: query
  });
}

export function createSign(query) {
  return request({
    url: "/api/merchant/user-sms/sign/create",
    method: "post",
    data: query
  });
}

export function deleteSign(query) {
  return request({
    url: "/api/merchant/user-sms/sign/delete",
    method: "post",
    data: query
  });
}

export function getTemplateList(query) {
  return request({
    url: "/api/merchant/batch-sms/template/list",
    method: "get",
    params: query
  });
}

export function getValidtemplateList(query) {
  return request({
    url: "/api/merchant/user-sms/validtemplate/list",
    method: "get",
    params: query
  });
}

export function editTemplate(query) {
  return request({
    url: "/api/merchant/user-sms/template/edit",
    method: "post",
    data: query
  });
}

export function createTemplate(query) {
  return request({
    url: "/api/merchant/user-sms/template/create",
    method: "post",
    data: query
  });
}

export function deleteTemplate(query) {
  return request({
    url: "/api/merchant/user-sms/template/delete",
    method: "post",
    data: query
  });
}

export function getRecordList(query) {
  return request({
    // url: '/api/merchant/batch-sms/batchSms',
    url: "/api/stat/sms/record-user/list",
    method: "get",
    params: query
  });
}
export function getRecordDetailList(query) {
  return request({
    url: "/api/merchant/batch-sms/batchSmsDetail",
    method: "get",
    params: query
  });
}
export function updateSmsSubmit(query) {
  return request({
    url: "/api/merchant/user-sms/submit",
    method: "post",
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/services/message.js